/**
 * Utilitaires de formatage — montants suisses et dates françaises.
 */
export function fmtCHF(n) {
  const parts = Number(n).toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return parts.join('.') + ' CHF';
}

const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
export const JOURS_ISO = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

export function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso.length === 10 ? iso + 'T00:00:00' : iso);
  if (isNaN(d)) return iso;
  return `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]} ${d.getFullYear()}`;
}

export function fmtDateHeure(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return `${fmtDate(iso)} à ${fmtHeure(iso)}`;
}

/** Heure seule, sur deux chiffres (18:30). */
export function fmtHeure(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';
  return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
}

/** Première lettre en majuscule — pour un jour en tête de ligne. */
export function capitaliser(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

/** « Vendredi 18 septembre 2026 » — jour capitalisé (début de ligne). */
export function fmtDateMaj(iso) {
  return capitaliser(fmtDate(iso));
}

/** « Vendredi 18 septembre 2026 à 18:30 » — jour capitalisé. */
export function fmtDateHeureMaj(iso) {
  return capitaliser(fmtDateHeure(iso));
}

export function isoLocal(d) {
  const p = (x) => String(x).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
